import React from 'react'
import {
  RegisterOptions,
  useController,
  useFormContext
} from 'react-hook-form'

import TextArea, {TextAreaProps} from '../inputs/TextArea'

export interface FormTextAreaProps
  extends Omit<TextAreaProps, 'value' | 'onChange' | 'onBlur'> {
  name: string;
  rules?: Omit<
  RegisterOptions,
  'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'
  >;
}

export const ControlledFormTextArea = ({
  name,
  rules,
  ...rest
}: FormTextAreaProps) => {
  const methods = useFormContext()

  const {field, fieldState} = useController({
    name,
    control: methods.control,
    rules
  })

  return (
    <TextArea
      {...rest}
      errorMessage={fieldState.error?.message}
      onChange={field.onChange} // send value to hook form
      props={{onBlur: field.onBlur, name: field.name}} // notify when input is touched/blur, send down the input name
      value={field.value} // input value
      ref={field.ref}
    />
  )
}

export default ControlledFormTextArea
